(() => {
  if (customElements.get('denali-scrollbar')) return;
  let nextId = 0;
  customElements.define('denali-scrollbar', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.scroller = this.previousElementSibling;
      if (!this.scroller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.thumb = document.createElement('span');
      this.thumb.className = 'denali-scrollbar__thumb';
      this.replaceChildren(this.thumb);
      this.mobileOnly = !!this.scroller.closest('.denali-comparison, .product-quick-nav');
      this.media = matchMedia('(max-width: 768px)');
      if (!this.scroller.id) this.scroller.id = `denali-scroll-area-${++nextId}`;
      this.setAttribute('role', 'scrollbar');
      this.setAttribute('aria-orientation', 'horizontal');
      this.setAttribute('aria-controls', this.scroller.id);
      this.setAttribute('aria-label', this.closest('.shopify-section')?.querySelector('h2')?.textContent.trim() || document.title);
      this.setAttribute('aria-valuemin', '0');
      this.setAttribute('aria-valuemax', '100');
      this.tabIndex = 0;
      this.update = () => {
        const enabled = !this.mobileOnly || this.media.matches;
        this.scroller.classList.toggle('denali-custom-scroll', enabled);
        this.max = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        this.hidden = !enabled || this.max < 2;
        if (this.hidden) return;
        this.rtl = getComputedStyle(this.scroller).direction === 'rtl';
        const width = this.clientWidth;
        this.thumbWidth = Math.min(width, Math.max(32, width * this.scroller.clientWidth / this.scroller.scrollWidth));
        this.travel = width - this.thumbWidth;
        const progress = Math.min(1, Math.max(0, Math.abs(this.scroller.scrollLeft) / this.max));
        this.thumb.style.width = `${this.thumbWidth}px`;
        this.thumb.style.transform = `translateX(${(this.rtl ? 1 - progress : progress) * this.travel}px)`;
        this.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
      };
      this.setProgress = (progress) => {
        this.scroller.scrollLeft = Math.min(1, Math.max(0, progress)) * this.max * (this.rtl ? -1 : 1);
      };
      this.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || !this.travel) return;
        event.preventDefault();
        this.focus({ preventScroll: true });
        this.pointerId = event.pointerId;
        this.setPointerCapture(event.pointerId);
        this.oldSnap = this.scroller.style.scrollSnapType;
        this.scroller.style.scrollSnapType = 'none';
        this.grabOffset = event.target === this.thumb ? event.clientX - this.thumb.getBoundingClientRect().left : this.thumbWidth / 2;
        this.move(event);
      }, { signal });
      this.move = (event) => {
        if (this.pointerId !== event.pointerId) return;
        const fraction = (event.clientX - this.getBoundingClientRect().left - this.grabOffset) / this.travel;
        this.setProgress(this.rtl ? 1 - fraction : fraction);
      };
      this.addEventListener('pointermove', this.move, { signal });
      const endDrag = () => {
        if (this.pointerId === undefined) return;
        this.pointerId = undefined;
        this.scroller.style.scrollSnapType = this.oldSnap;
      };
      this.addEventListener('pointerup', endDrag, { signal });
      this.addEventListener('pointercancel', endDrag, { signal });
      this.addEventListener('lostpointercapture', endDrag, { signal });
      this.addEventListener('keydown', (event) => {
        const progress = Math.abs(this.scroller.scrollLeft) / this.max;
        const step = this.scroller.clientWidth * 0.8 / this.max;
        const direction = this.rtl ? -1 : 1;
        const values = { Home: 0, End: 1, ArrowLeft: progress - step * direction, ArrowRight: progress + step * direction, PageUp: progress - step, PageDown: progress + step };
        if (!(event.key in values)) return;
        event.preventDefault();
        this.setProgress(values[event.key]);
      }, { signal });
      this.scroller.addEventListener('scroll', this.update, { passive: true, signal });
      this.scroller.addEventListener('load', this.update, { capture: true, signal });
      this.media.addEventListener('change', this.update, { signal });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.scroller);
      Array.from(this.scroller.children).forEach((child) => this.observer.observe(child));
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.scroller?.classList.remove('denali-custom-scroll');
      if (this.pointerId !== undefined) this.scroller.style.scrollSnapType = this.oldSnap;
    }
  });
  const init = (root) => {
    root.querySelectorAll('denali-features .denali-track, denali-video-reviews .denali-track, denali-product-cards .denali-products, blog-content-carousel[data-scroll-mode="scrollbar"] .blog-swiper, .denali-comparison .product-comparison-slider, .product-quick-nav > .container').forEach((scroller) => {
      if (scroller.nextElementSibling?.tagName === 'DENALI-SCROLLBAR') return;
      scroller.after(document.createElement('denali-scrollbar'));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
